import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f30ffd74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "breadcrumb" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "title" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(9, (index) => {
        return _createElementVNode("li", { key: index }, [
          _hoisted_2,
          (index <= _ctx.visitedThemes.length)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: ($event: any) => (_ctx.showTheme(_ctx.visitedThemes[index-1]))
              }, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.getThemeTitle(_ctx.visitedThemes[index-1])), 1),
                _createElementVNode("img", {
                  src: _ctx.getImage(_ctx.visitedThemes[index-1]),
                  alt: ""
                }, null, 8, _hoisted_5)
              ], 8, _hoisted_3))
            : _createCommentVNode("", true)
        ])
      }), 64))
    ])
  ]))
}